<div class="spinner-wrapper" *ngIf="showLoader">
  <mat-spinner></mat-spinner>
</div>
<div class="container design-overview-wrapper">
  <h2>System Overview</h2>
  <hr>
  <div class="breadcrumb">
    <ul class="d-flex align-items-center breadcrumb__list">
      <li class="breadcrumb__list__list-item"><a class="breadcrumb__list__list-item__link" routerLink="/home">Home</a>
      </li>
      <li class="breadcrumb__list__list-item"><a class="breadcrumb__list__list-item__link"
          routerLink="/system">Systems</a>
      </li>
      <li class="breadcrumb__list__list-item"><a class="breadcrumb__list__list-item__link">{{system?.name}}</a>
      </li>
    </ul>
  </div>
  <div class="design-overview-wrapper__item">
    <div class="col-md-6 col-12">
      <p class="design-overview-wrapper__item__title mb-0">{{system?.name}} </p>
      <p class="design-overview-wrapper__item__detail mb-3"> Design ID : {{system?.design_id}}

      </p>
      <p class="design-overview-wrapper__item__detail mb-3"> System ID : {{system?.id}}
      </p>
    </div>
    <div class="design-overview-wrapper__item">
      <div class="d-flex">
        <div class="pe-3">
          <span class="design-overview-wrapper__item__item-number">
            2.1
          </span>
        </div>
        <div class="ps-3">
          <p class="design-overview-wrapper__item__title">Ventilation airflow design rate & run-time meet the requirements of ASHRAE 62.2-2010, 2013, or 2016.</p>
          <p class="design-overview-wrapper__item__detail"> {{system?.radio1}}
          </p>
        </div>
      </div>
    </div>
    <div class="design-overview-wrapper__item">
      <div class="d-flex">
        <div class="pe-3">
          <span class="design-overview-wrapper__item__item-number">
            2.2
          </span>
        </div>
        <div class="ps-3">
          <p class="design-overview-wrapper__item__title">Ventilation airflow rate required by 62.2 for a continuous system</p>
          <p class="design-overview-wrapper__item__detail"> {{system?.ventairrate}}
          </p>
        </div>
      </div>
    </div>
    <div class="d-flex flex-wrap">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number">
          2.3
        </span>
      </div>
      <div class="ps-3 flex-grow-1">
        <div class="d-flex flex-wrap">
          <div class="col-md-6 col-12">
            <p class="design-overview-wrapper__item__title mb-0">Designer for this system:</p>

          </div>
          <div class="col-md-6 col-12">

          </div>
          <div class="col-md-6 col-12">
            <p class="design-overview-wrapper__item__title mb-0">Ventilation airflow rate
            </p>
            <p class="design-overview-wrapper__item__detail mb-3">{{system?.venairflo0}} CFM
            </p>
          </div>
          <div class="col-md-6 col-12">
            <p class="design-overview-wrapper__item__title mb-0">Run-time per cycle:</p>
            <p class="design-overview-wrapper__item__detail mb-3"> {{system?.runtimecyc}} minutes
            </p>
          </div>
          <div class="col-md-6 col-12">
            <p class="design-overview-wrapper__item__title mb-0">Cycle time
            </p>
            <p class="design-overview-wrapper__item__detail mb-3"> {{system?.cycletimes}} minutes
            </p>
          </div>

        </div>
      </div>
    </div>
    <div class="design-overview-wrapper__item">
      <div class="d-flex">
        <div class="pe-3">
          <span class="design-overview-wrapper__item__item-number">
            2.4
          </span>
        </div>
        <div class="ps-3">
          <p class="design-overview-wrapper__item__title">Specified system type:</p>
          <p class="design-overview-wrapper__item__detail"> {{system?.specifiedsystype}}
          </p>
        </div>
      </div>
    </div>
    <div class="design-overview-wrapper__item">
      <div class="d-flex">
        <div class="pe-3">
          <span class="design-overview-wrapper__item__item-number">
            2.5
          </span>
        </div>
        <div class="ps-3">
          <p class="design-overview-wrapper__item__title">Specified control location:</p>
          <p class="design-overview-wrapper__item__detail"> {{system?.contlocspe}}

          </p>
        </div>
      </div>
    </div>
    <div class="design-overview-wrapper__item">
      <div class="d-flex">
        <div class="pe-3">
          <span class="design-overview-wrapper__item__item-number">
            2.6
          </span>
        </div>
        <div class="ps-3">
          <p class="design-overview-wrapper__item__title">Specified controls allow the system to operate automatically,
            without occupant intervention:</p>
          <p class="design-overview-wrapper__item__detail"> {{system?.opwointrvntn}}

          </p>
        </div>
      </div>
    </div>
    <div class="design-overview-wrapper__item">
      <div class="d-flex">
        <div class="pe-3">
          <span class="design-overview-wrapper__item__item-number">
            2.7
          </span>
        </div>
        <div class="ps-3">
          <p class="design-overview-wrapper__item__title"> Specified controls include a readily-accessible ventilation
            override and a label has also been specified if its function is not obvious (e.g., a label is required for a
            standalone wall switch, but not for a switch that's on the ventilation equipment)</p>
          <p class="design-overview-wrapper__item__detail"> {{system?.ventoverride}}

          </p>
        </div>
      </div>
    </div>
    <div class="design-overview-wrapper__item">
      <div class="d-flex">
        <div class="pe-3">
          <span class="design-overview-wrapper__item__item-number">
            2.8
          </span>
        </div>
        <div class="ps-3">
          <p class="design-overview-wrapper__item__title"> No outdoor air intakes designed to connect to the return
            side of the HVAC system unless specified controls operate intermittently and automatically based on a timer
            and restrict intake when not in use (e.g., motorized damper):</p>
          <p class="design-overview-wrapper__item__detail"> {{system?.useintakeright}}

          </p>
        </div>
      </div>
    </div>
    <div class="design-overview-wrapper__item">
      <div class="d-flex">
        <div class="pe-3">
          <span class="design-overview-wrapper__item__item-number">
            2.9
          </span>
        </div>
        <div class="ps-3">
          <p class="design-overview-wrapper__item__title"> The Fan of the specified system is rated <= 3 sones if
              intermittent, and <=1 sone if continuous or exempted </p>
              <p class="design-overview-wrapper__item__detail"> {{system?.fanratedsones}}

              </p>
        </div>
      </div>
    </div>
    <div class="design-overview-wrapper__item">
      <div class="d-flex">
        <div class="pe-3">
          <span class="design-overview-wrapper__item__item-number">
            2.10
          </span>
        </div>
        <div class="ps-3">
          <p class="design-overview-wrapper__item__title">If Vent System controller operates the HVAC fan, then HVAC fan operation is intermittent and either the fan type in Item 4.7 is ECM / ICM or the controls will reduce the run-time by accounting for HVAC system heating or cooling hours. </p>
          <p class="design-overview-wrapper__item__detail"> {{system?.fanreducevnt}}

          </p>
        </div>
      </div>
    </div>
    <div class="design-overview-wrapper__item">
      <div class="d-flex">
        <div class="pe-3">
          <span class="design-overview-wrapper__item__item-number">
            2.11
          </span>
        </div>
        <div class="ps-3">
          <p class="design-overview-wrapper__item__title"> If bathroom fans are specified as a part of this system,
            then they are ENERGY STAR certified.</p>
          <p class="design-overview-wrapper__item__detail"> {{system?.bathroomfanses}}

          </p>
        </div>
      </div>
    </div>
    <div class="design-overview-wrapper__item">
      <div class="d-flex">
        <div class="pe-3">
          <span class="design-overview-wrapper__item__item-number">
            2.12
          </span>
        </div>
        <div class="ps-3">
          <p class="design-overview-wrapper__item__title"> Inlet pulls ventilation air directly from outdoors and not
            from attic, crawlspace, garage, or adjacent dwelling unit.</p>
          <p class="design-overview-wrapper__item__detail"> {{system?.inletpullsoutdr}}

          </p>
        </div>
      </div>
    </div>
    <div class="design-overview-wrapper__item">
      <div class="d-flex">
        <div class="pe-3">
          <span class="design-overview-wrapper__item__item-number">
            2.13
          </span>
        </div>
        <div class="ps-3">
          <p class="design-overview-wrapper__item__title">Inlet is >= 2ft. above grade or roof deck; >= 10ft. of stretched-string distance from known contamination sources not exiting the roof, and >= 3ft from known sources exiting the roof.</p>
          <p class="design-overview-wrapper__item__detail"> {{system?.inletlocation}}

          </p>
        </div>
      </div>
    </div>
    <div class="design-overview-wrapper__item">
      <div class="d-flex">
        <div class="pe-3">
          <span class="design-overview-wrapper__item__item-number">
            3.10
          </span>
        </div>
        <div class="ps-3 flex-grow-1">
          <div class="d-flex flex-wrap">
            <div class="col-12">
              <p class="design-overview-wrapper__item__title mb-0"> Design Sensible Heat Gain
              </p>
            </div>
            <div class="col-md-6 col-12">
              <p class="design-overview-wrapper__item__detail mb-3">N - {{system?.dessheatgainn}}
              </p>
            </div>
            <div class="col-md-6 col-12">
              <p class="design-overview-wrapper__item__detail mb-3">NE - {{system?.dessheatgainne}}
              </p>
            </div>
            <div class="col-md-6 col-12">
              <p class="design-overview-wrapper__item__detail mb-3">E - {{system?.dessheatgaine}}
              </p>
            </div>
            <div class="col-md-6 col-12">
              <p class="design-overview-wrapper__item__detail mb-3">SE - {{system?.dessheatgainse}}
              </p>
            </div>
            <div class="col-md-6 col-12">
              <p class="design-overview-wrapper__item__detail mb-3">S - {{system?.dessheatgains}}
              </p>
            </div>
            <div class="col-md-6 col-12">
              <p class="design-overview-wrapper__item__detail mb-3">SW - {{system?.dessheatgainsw}}
              </p>
            </div>
            <div class="col-md-6 col-12">
              <p class="design-overview-wrapper__item__detail mb-3">W - {{system?.dessheatgainw}}
              </p>
            </div>
            <div class="col-md-6 col-12">
              <p class="design-overview-wrapper__item__detail mb-3">NW - {{system?.dessheatgainnw}}
              </p>
            </div>
            <div class="col-md-6 col-12">
              <p class="design-overview-wrapper__item__detail mb-3">Max Heat Gain - {{system?.maxheatgain}}
              </p>
            </div>


          </div>
        </div>
      </div>
    </div>

    <div class="design-overview-wrapper__item">
      <div class="d-flex">
        <div class="pe-3">
          <span class="design-overview-wrapper__item__item-number">
            3.11
          </span>
        </div>
        <div class="ps-3">
          <p class="design-overview-wrapper__item__title">Design Latent Heat Gain</p>
          <p class="design-overview-wrapper__item__detail"> {{system?.deslheatgain}}
          </p>
        </div>
      </div>
    </div>

    <div class="design-overview-wrapper__item">
      <div class="d-flex">
        <div class="pe-3">
          <span class="design-overview-wrapper__item__item-number">
            3.12
          </span>
        </div>
        <div class="ps-3 flex-grow-1">
          <div class="d-flex flex-wrap">
            <div class="col-12">
              <p class="design-overview-wrapper__item__title mb-0"> Design Total Heat Gain
              </p>
            </div>
            <div class="col-md-6 col-12">
              <p class="design-overview-wrapper__item__detail mb-3">N - {{ returnFixed(system?.destotlheatgainn || 0) }}
              </p>
            </div>
            <div class="col-md-6 col-12">
              <p class="design-overview-wrapper__item__detail mb-3">NE - {{  returnFixed(system?.destotlheatgainne || 0) }}
              </p>
            </div>
            <div class="col-md-6 col-12">
              <p class="design-overview-wrapper__item__detail mb-3">E - {{returnFixed(system?.destotlheatgaine || 0) }}
              </p>
            </div>
            <div class="col-md-6 col-12">
              <p class="design-overview-wrapper__item__detail mb-3">SE - {{returnFixed(system?.destotlheatgainse || 0) }}
              </p>
            </div>
            <div class="col-md-6 col-12">
              <p class="design-overview-wrapper__item__detail mb-3">S - {{returnFixed(system?.destotlheatgains || 0) }}
              </p>
            </div>
            <div class="col-md-6 col-12">
              <p class="design-overview-wrapper__item__detail mb-3">SW - {{returnFixed(system?.destotlheatgainsw || 0) }}
              </p>
            </div>
            <div class="col-md-6 col-12">
              <p class="design-overview-wrapper__item__detail mb-3">W - {{returnFixed(system?.destotlheatgainw || 0) }}
              </p>
            </div>
            <div class="col-md-6 col-12">
              <p class="design-overview-wrapper__item__detail mb-3">NW - {{returnFixed(system?.destotlheatgainnw || 0) }}
              </p>
            </div>
            <div class="col-md-6 col-12">
              <p class="design-overview-wrapper__item__detail mb-3">The Max Total - {{returnFixed(system?.maxtotal) }}
              </p>
            </div>
            <div class="col-md-6 col-12">
              <p class="design-overview-wrapper__item__detail mb-3">The Minimum - {{returnFixed(system?.hrt) }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="design-overview-wrapper__item">
      <div class="d-flex">
        <div class="pe-3">
          <span class="design-overview-wrapper__item__item-number">
            3.13
          </span>
        </div>
        <div class="ps-3">
          <p class="design-overview-wrapper__item__title"> Maximum minus minimum total heat gain (Item 3.12) across orientations(The Difference)</p>
          <p class="design-overview-wrapper__item__detail"> The Difference - {{returnFixed(system?.gfh) }}
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number">
          3.14
        </span>
      </div>
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title"> Design Total Heat Loss</p>
        <p class="design-overview-wrapper__item__detail">{{system?.desttotlheatloss}}
        </p>
      </div>
    </div>
  </div>
  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number">
          4.1
        </span>
      </div>
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title">Equipment selected per ACCA Manual S</p>
        <p class="design-overview-wrapper__item__detail">
          {{system?.equipmentname}} -
            {{system?.equipmentdescription}}
        </p>
      </div>
    </div>
  </div>
  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number">
          4.13
        </span>
      </div>
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title">Cooling Sizing % = Total Capacity (4.11) divided by maxmun
          total heat gain (3.12)</p>
        <p class="design-overview-wrapper__item__detail">{{returnFixed(system?.coolsizingpct) }}%
        </p>
      </div>
    </div>
  </div>

  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number">
          4.15
        </span>
      </div>
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title"> Check the box of the applicable cooling sizing limit from the
          choice below</p>
        <p class="design-overview-wrapper__item__detail">{{system?.coolingsizinglimit}}
        </p>
      </div>
    </div>
  </div>

  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number">
          4.16
        </span>
      </div>
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title"> Cooling sizing % (4.13) is within cooling sizing limit (4.15)
        </p>
        <p class="design-overview-wrapper__item__detail">Designer Verified - {{returnFixed(system?.coolsizepctlimit)}}
        </p>
      </div>
    </div>
  </div>

  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number">
          4.20
        </span>
      </div>
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title"> Heating sizing % = Total capacity (4.19) divided by total heat
          loss (3.14)
        </p>
        <p class="design-overview-wrapper__item__detail">% {{(system?.heatsizepctlimits) * 100}}
        </p>
      </div>
    </div>
  </div>
  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number">
          4.21
        </span>
      </div>
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title"> Check box of applicable heating sizing limit from below
        </p>
        <p class="design-overview-wrapper__item__detail"> {{system?.heatsizinglimit}}
        </p>
      </div>
    </div>
  </div>
  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number">
          4.22
        </span>
      </div>
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title"> Heating sizing % (4.20) is within heating sizing limit (4.21)
        </p>
        <p class="design-overview-wrapper__item__detail">Designer Verified - {{system?.heatsizepctlimit}}
        </p>
      </div>
    </div>
  </div>
  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number">
          5.1
        </span>
      </div>
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title"> Duct system designed for the equipment selected in Section 4,
          per ACCA Manual D
        </p>
        <p class="design-overview-wrapper__item__detail">{{system?.manuald}}
        </p>
      </div>
    </div>
  </div>
  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number">
          5.2
        </span>
      </div>
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title"> Design HVAC fan Airflow
        </p>
        <p class="design-overview-wrapper__item__detail">Cooling Mode - {{system?.designairflowcool}} (CFM)
        </p>
        <p class="design-overview-wrapper__item__detail">Heating Mode - {{system?.designairflowheat}} (CFM)
        </p>
      </div>
    </div>
  </div>
  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number">
          5.3
        </span>
      </div>
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title"> HVAC Fan Speed setting (e.g. low, medium, high)
        </p>
        <p class="design-overview-wrapper__item__detail">Cooling Mode - {{system?.hvacfanspdcool}}
        </p>
        <p class="design-overview-wrapper__item__detail">Heating Mode - {{system?.hvacfanspdheat}}
        </p>
      </div>
    </div>
  </div>
  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number">
          5.4
        </span>
      </div>
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title"> Design Total External Static pressure (IWC)
        </p>
        <p class="design-overview-wrapper__item__detail">Heating Mode - {{system?.designstaticp}}
        </p>
      </div>
    </div>
  </div>
  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number">
          5.5
        </span>
      </div>

      <div class="ps-3 flex-grow-1">
        <div class="d-flex flex-wrap">
          <div class="col-12">
            <p class="design-overview-wrapper__item__title mb-0"> Room-by-room airflow design documented
            </p>
          </div>
          <div class="col-md-6 col-12" style="text-align:center;">
            <p class="design-overview-wrapper__item__detail mb-3" > Description
            </p>
          </div>
          <div class="col-md-6 col-12" style="text-align:center;">
            <p class="design-overview-wrapper__item__detail mb-3" >Design Airflow CFM
            </p>
          </div>
        </div>
      </div>



  </div>

  <div *ngFor="let room of rooms" style="display:flex;">
    <div class="col-md-6 col-12" style="margin-left: 60px; border-style: solid; border-width:2px; width:45%;">
      <p class="design-overview-wrapper__item__detail mb-3" style="background: white"> {{room.room_descr}}
      </p>
    </div>
    <div class="col-md-6 col-12" style="border-style: solid; border-width:2px;">
      <p class="design-overview-wrapper__item__detail mb-3" style="background: white"> {{room.dsh_heat_flow}}
      </p>
  </div>
</div>

<div *ngIf="rooms" style="display:flex;">
  <div class="col-md-6 col-12" style="margin-left: 60px; border-style: solid; border-width:2px; width:45%;">
    <p class="design-overview-wrapper__item__detail mb-3" style="background: lightblue"> Total
    </p>
  </div>
  <div class="col-md-6 col-12" style="border-style: solid; border-width:2px;">
    <p class="design-overview-wrapper__item__detail mb-3" style="background: lightblue"> {{this.roomsTotal}}
    </p>
  </div>
</div>

  <div class="row col-8 center-block dashboard-btn-row">
    <div class="d-flex my-3">
      <button mat-flat-button color="primary" class="me-3" [routerLink]="['/new-system-design']"
        [queryParams]="{id: system?.id, editMode:true}">EDIT</button>
      <button mat-flat-button color="warn" class="me-3" type="button" data-toggle="collapse" data-target="#dds3"
        (click)="delete(system.id)" aria-expanded="false" aria-controls="dds3">
        DELETE
      </button>
      <button mat-flat-button color="basic" type="button" [routerLink]="['/system']" data-toggle="collapse"
      data-target="#dds3" aria-expanded="false" aria-controls="dds3">
      Back
    </button>
    </div>
  </div>
</div>
